export default __webpack_public_path__ + "static/portfolio_gallery_21-622f4bc8da3dfc69021cba9ad0ad4d11.jpg";